import React, { useEffect } from 'react';
import { Button, Dropdown, TextInput } from 'flowbite-react';
import PBLogo from '../../Assets/PriceBros-Logo.png';
import { useAppDispatch, useAppSelector } from '../../Reducers/store';
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { SearchRequest } from '../../Models/SearchRequest';
import { toast } from 'react-toastify';
import { fetchCurrentUser } from '../../Actions';
import { HiMenu } from 'react-icons/hi';
import { MdShoppingCart } from 'react-icons/md';
import { FaUser } from 'react-icons/fa';
import { UserLevelNames } from '../../Models/UserLevel';
import { useLocation } from 'react-router-dom';

export default function TopNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { userModel } = useAppSelector((state) => state.user);

  const logout = () => {
    localStorage.removeItem('PriceBrosToken');
    dispatch(fetchCurrentUser());
  };

  const [formData, setFormData] = useState<SearchRequest>({
    searchText: localStorage.getItem('searchTextState') ?? '',
    manufacturers: null,
    categories: null,
    subCategories: null,
    minPrice: null,
    maxPrice: null,
    limit: 30,
    skip: 0,
    reset: false,
    equipmentType: 1,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [orderItemsCount, setOrderItemsCount] = useState<number>(0);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    localStorage.setItem('manufacturersState', '');
    localStorage.setItem('categoriesState', '');
    localStorage.setItem('subCategoriesState', '');
    localStorage.setItem('searchTextState', '');
    localStorage.setItem('minPriceState', '');
    localStorage.setItem('maxPriceState', '');
    localStorage.setItem('equipmentTypeState', '1');
    localStorage.setItem('searchTextState', formData.searchText ?? '');
    setFormData((prevData) => ({ ...prevData }));
    navigate('/products/search', { replace: true });
  };

  const handlePartsClick = () => {
    localStorage.setItem('manufacturersState', '');
    localStorage.setItem('categoriesState', '');
    localStorage.setItem('subCategoriesState', '');
    //localStorage.setItem('searchPartsTextState', '');
    localStorage.setItem('minPriceState', '');
    localStorage.setItem('maxPriceState', '');
    localStorage.setItem('equipmentTypeState', '2');
    navigate('/products/search/parts', { replace: true });
  };

  useEffect(() => {
    const count =
      localStorage.getItem('orderItemsCount') &&
      Number(localStorage.getItem('orderItemsCount')) >= 0
        ? Number(localStorage.getItem('orderItemsCount'))
        : 0;
    setOrderItemsCount(count);
    function checkOrderItemsCount() {
      const count =
        localStorage.getItem('orderItemsCount') &&
        Number(localStorage.getItem('orderItemsCount')) >= 0
          ? Number(localStorage.getItem('orderItemsCount'))
          : 0;
      setOrderItemsCount(count);
    }

    window.addEventListener('updateOrderItemCount', checkOrderItemsCount);

    return () => {
      window.removeEventListener('updateOrderItemCount', checkOrderItemsCount);
    };
  }, []);

  function checkAccess() {
    // if (userModel && userModel.userLevelId === UserLevelNames.SuperAdmin) {
    if (userModel?.userLevelId === UserLevelNames.Admin) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      <div className='w-full sticky top-0 z-10'>
        <div className='flex bg-black px-4 justify-between h-[58px]'>
          <Link to={'/'} className='w-[70px]'>
            {/* <Navbar.Brand href='/'> */}
            <img src={PBLogo} className='mr-3 h-12' alt='Price Bros' />
            {/* </Navbar.Brand> */}
          </Link>
          <div className={` w-2/3 lg:w-1/3`}>
            <div className='w-full p-2'>
              <form onSubmit={onSubmit} className='flex'>
                <TextInput
                  id='searchText'
                  name='searchText'
                  type='text'
                  placeholder='Search by Number, Model, or Description..'
                  onChange={handleChange}
                  value={formData.searchText ?? ''}
                  className='w-full pr-1'
                />
                <Button type='submit' className='buttonMain'>
                  Search
                </Button>
              </form>
            </div>
          </div>
          <div className='flex my-auto'>
            <div className='hidden lg:flex'>
              <Link to={'/'}>
                <Button className='text-white'>Home</Button>
              </Link>
              <Link to={'/products/manufacturers'}>
                <Button className='text-white'>Manufacturers</Button>
              </Link>
              <Link to={'/products/categories'}>
                <Button className='text-white px-0'>Wholegoods</Button>
              </Link>

              <Link to={'/manuals'}>
                <Button className='text-white px-0'>Manuals</Button>
              </Link>
              <Button onClick={handlePartsClick} className='text-white px-0'>
                Parts
              </Button>
              <Dropdown arrowIcon={false} label={'Warranty'}>
                <Link
                  className='flex content-center py-1 px-2 hover:bg-gray-100'
                  to={'/warranty/claim'}
                >
                  New Claim
                </Link>
                {userModel && (
                  <Link
                    className='flex content-center py-1 px-2 hover:bg-gray-100'
                    to={'/warranty/myclaims'}
                  >
                    View Claims
                  </Link>
                )}
              </Dropdown>
              <Link to={'/dealerlocator'}>
                <Button className='text-white px-0'>Dealer Locator</Button>
              </Link>
              {userModel && (
                <Link
                  to={'/orders/view'}
                  className='relative inline-flex m-auto px-2'
                >
                  <MdShoppingCart color='white' size={20} />
                  {orderItemsCount > 0 && (
                    <span className='absolute rounded-full text-xs font-medium flex justify-center place-items-center translate-x-3/4 -translate-y-3/4 bg-red-500 text-white w-[20px] h-[20px]'>
                      {orderItemsCount}
                    </span>
                  )}
                </Link>
              )}
              <div className='mx-2'></div>
              {!userModel && (
                <Link to={'/login'}>
                  <Button>Dealer Login</Button>
                </Link>
              )}
              {userModel && (
                <Dropdown
                  arrowIcon={false}
                  label={<FaUser color='white' size={20} />}
                >
                  <Link
                    className='flex content-center py-1 px-2 hover:bg-gray-100'
                    to={`/user/${userModel?.id}`}
                  >
                    Profile
                  </Link>
                  {!checkAccess() && (
                    <Link
                      className='flex content-center py-1 px-2 hover:bg-gray-100'
                      to={`/orders/list`}
                    >
                      Orders
                    </Link>
                  )}
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={logout} className='text-red-700'>
                    Logout
                  </Dropdown.Item>
                </Dropdown>
              )}
            </div>
            <div className='block lg:hidden'>
              <Dropdown
                label=''
                dismissOnClick={false}
                renderTrigger={() => (
                  <div>
                    <HiMenu size={35} className='text-white cursor-pointer' />
                  </div>
                )}
              >
                {userModel && userModel.userLevelId == UserLevelNames.Admin && (
                  <Dropdown.Item>
                    <Dropdown
                      label=''
                      dismissOnClick={false}
                      renderTrigger={() => <div>Admin</div>}
                      placement='left'
                    >
                      <Dropdown.Item href='/dashboard'>Dashboard</Dropdown.Item>
                      <Dropdown.Item href='/users'>Users</Dropdown.Item>
                      <Dropdown.Item href='/manufacturers'>
                        Manufacturers
                      </Dropdown.Item>
                      <Dropdown.Item href='/equipmentlist'>
                        Equipment
                      </Dropdown.Item>
                      <Dropdown.Item href='/partslist'>Parts</Dropdown.Item>
                      <Dropdown.Item href='/siteresources'>
                        Site Resources
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Dropdown
                          label=''
                          dismissOnClick={false}
                          renderTrigger={() => <div>Forms</div>}
                          placement='left'
                        >
                          <Dropdown.Item href='/contactforms'>
                            Potential Opportunities
                          </Dropdown.Item>
                          <Dropdown.Item href='/requestQuotes'>
                            Quote Requests
                          </Dropdown.Item>
                        </Dropdown>
                      </Dropdown.Item>
                    </Dropdown>
                  </Dropdown.Item>
                )}
                <Dropdown.Item>
                  <Link to={'/'}>Home</Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to={'/products/manufacturers'}>Manufacturers</Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to={'/products/categories'}>Wholegoods</Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <div onClick={handlePartsClick} className=''>
                    Parts
                  </div>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Dropdown
                    label=''
                    dismissOnClick={false}
                    renderTrigger={() => <div>Warranty</div>}
                    placement='left'
                  >
                    <Dropdown.Item>
                      <Link className='' to={'/warranty/claim'}>
                        New Claim
                      </Link>
                    </Dropdown.Item>
                    {userModel && (
                      <Dropdown.Item href={'/warranty/myclaims'}>
                        View Claims
                      </Dropdown.Item>
                    )}{' '}
                  </Dropdown>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to={'/dealerlocator'}>Dealer Locator</Link>
                </Dropdown.Item>
                {userModel && (
                  <Dropdown.Item>
                    <Link className='flex gap-2' to={'/orders/view'}>
                      Cart
                      {orderItemsCount > 0 && (
                        <span className='rounded-full text-xs font-medium flex justify-center place-items-center bg-red-500 text-white w-[20px] h-[20px]'>
                          {orderItemsCount}
                        </span>
                      )}
                    </Link>
                  </Dropdown.Item>
                )}
                <Dropdown.Item>
                  <Dropdown
                    label=''
                    dismissOnClick={false}
                    renderTrigger={() => <div>About Us</div>}
                    placement='left'
                  >
                    <Dropdown.Item href='/about'>About Us</Dropdown.Item>
                    <Dropdown.Item href='/contact'>Contact</Dropdown.Item>
                  </Dropdown>
                </Dropdown.Item>
                <Dropdown.Item>
                  {!userModel && (
                    <Link to={'/login'} className='text-green-600'>
                      Dealer Login
                    </Link>
                  )}
                  {userModel && (
                    <div onClick={logout} className='text-red-500'>
                      Logout
                    </div>
                  )}
                </Dropdown.Item>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
